<template>
  <v-card :color="background('color')" :min-height="$vuetify.breakpoint.height">
    <v-img :style="backgroundStyle()" :min-height="$vuetify.breakpoint.height">
      <CarouselBox class="mt-8" :items="carouselItems" :hideDelimiter="true" :fixHeight="carouselFixHeight" @click.native="carouselHandler()" />
      <v-col v-for="list in filterList" :key="list.name">
        <CardList :data="list" :key="list.name" :styleInfo="styleInfo" @click="cardHandler(list.name)" />
      </v-col>
    </v-img>
  </v-card>
</template>

<script>
import { mapState } from 'vuex';
import CarouselBox from '@/components/CarouselBox.vue';
import CardList from '../components/CardList.vue';

export default {
  name: 'Custom2',
  props: {},
  components: { CarouselBox, CardList },
  data: () => ({}),
  computed: {
    ...mapState('dbTable', ['filterList', 'filterSubject', 'customList']),
    styleInfo() {
      if (!this.filterSubject) return {};
      return this.customList.find((x) => x.id === this.filterSubject).styleInfo;
    },
    carouselFixHeight() {
      return this.styleInfo.boardHeight === '' ? 'auto' : this.styleInfo.boardHeight;
    },
    carouselItems() {
      if (!Object.prototype.hasOwnProperty.call(this.styleInfo, 'board')) return [];
      return this.styleInfo.board.map((x) => ({ src: `${process.env.VUE_APP_S3_URL}${x}` }));
    },
  },
  created() {
    if (!this.filterSubject) {
      this.$router.push({ name: 'main' });
    }
  },
  methods: {
    background(type) {
      if (!this.filterSubject || this.styleInfo.background.type !== type) return '';
      // if (this.styleInfo.background.type === 'image' && this.styleInfo.background.image === '') return './bg.jpg';
      return this.styleInfo.background.type === 'color'
        ? this.styleInfo.background.color
        : `${process.env.VUE_APP_S3_URL}${this.styleInfo.background.image}`;
    },
    backgroundStyle() {
      if (!this.filterSubject || this.styleInfo.background.type !== 'image') return '';
      if (this.styleInfo.background.image === '') {
        return {
          backgroundImage: 'url(./bg.jpg)',
          backgroundRepeat: 'repeat',
          backgroundSize: 'contain',
        };
      }
      return {
        backgroundImage: `url(${process.env.VUE_APP_S3_URL}${this.styleInfo.background.image})`,
        backgroundRepeat: 'repeat',
        backgroundSize: 'contain',
      };
    },
    carouselHandler() {
      if (Object.prototype.hasOwnProperty.call(this.styleInfo, 'boardHyperlink') && this.styleInfo.boardHyperlink !== '') {
        window.open(this.styleInfo.boardHyperlink);
      }
    },
    cardHandler(productName) {
      this.$router.push({ name: 'cardDetail', params: { productName } });
    },
  },
};
</script>
